import { palette } from '../global/palette';
import { boxShadow } from '../global/shadows';
import { typography } from '../global/typography';
export const MuiFab = {
    MuiFab: {
        styleOverrides: {
            root: Object.assign(Object.assign({}, typography.h6), { fontSize: typography.pxToRem(15), '& .MuiBadge-root': {
                    marginRight: 18,
                }, '& svg:not(.MuiBadge-root svg)': {
                    marginLeft: 27,
                }, boxShadow: boxShadow.large, '&:hover': {
                    backgroundColor: palette.primary.light,
                }, '&:active': {
                    backgroundColor: palette.primary.dark,
                }, '&:focus-visible': {
                    backgroundColor: palette.primary.dark,
                } }),
            extended: {
                padding: '12px 24px',
                minHeight: 54,
                borderRadius: 50,
            },
        },
        defaultProps: {
            variant: 'extended',
            color: 'primary',
        },
    },
};
